import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { AddressTypeKeys } from "../../../../../../../../util/enums";
import { useDespatchContext } from "../../../../context/DespatchContext";
import { DespatchSectionTitle } from "../../../components/SectionTitle";
import { ManageAddressesCard } from "./components/ManageAddressesCard";

export const DespatchAddressesSection = () => {
  const { t: translate } = useTranslation();
  const { despatch } = useDespatchContext();

  return (
    <Grid container spacing={2}>
      <DespatchSectionTitle>{translate("addresses")}</DespatchSectionTitle>
      <Grid container item spacing={2}>
        <Grid item xs={12} md={5}>
          <ManageAddressesCard
            type="pickUp"
            emptyMessage={translate("noPickupAddressAddedYet")}
            locations={despatch?.[AddressTypeKeys.ORIGIN_ADDRESS] ?? []}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <ManageAddressesCard
            type="delivery"
            emptyMessage={translate("noDeliveryAddressAddedYet")}
            locations={despatch?.[AddressTypeKeys.DESTINATION_ADDRESS] ?? []}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
